/**
 * Cal.com embed configuration — single source of truth for the site-wide
 * booking calendar (element-click embed, namespace "ifa").
 *
 * Any element anywhere on the site can open the calendar by carrying:
 *   data-cal-link="storily/ifa"
 *   data-cal-namespace="ifa"
 *   data-cal-config='{"layout":"month_view","useSlotsViewOnSmallScreen":"true"}'
 * (the embed script is initialized globally by src/hooks/useCalEmbed.ts).
 *
 * The React modal components (BookingPopup, CalendarPopup, CalendarDialog)
 * read the same constants, so changing the link here updates every surface.
 */

export const CAL_NAMESPACE = 'ifa';
export const CAL_LINK = 'storily/ifa';
export const CAL_ORIGIN = 'https://app.cal.com';

/** Namespace-level UI settings (Cal.ns.ifa("ui", ...)) */
export const CAL_UI_CONFIG = {
  hideEventTypeDetails: false,
  layout: 'month_view',
} as const;

/** Per-trigger config for element-click embeds and inline <Cal /> mounts */
export const CAL_CLICK_CONFIG = {
  layout: 'month_view',
  useSlotsViewOnSmallScreen: 'true',
} as const;

/** Ready-to-spread props for any DOM element that should open the calendar */
export const calTriggerProps = {
  'data-cal-link': CAL_LINK,
  'data-cal-namespace': CAL_NAMESPACE,
  'data-cal-config': JSON.stringify(CAL_CLICK_CONFIG),
} as const;
